import { render, staticRenderFns } from "./proposal.vue?vue&type=template&id=8f9c334a&scoped=true&"
import script from "./proposal.vue?vue&type=script&lang=js&"
export * from "./proposal.vue?vue&type=script&lang=js&"
import style0 from "./proposal.vue?vue&type=style&index=0&id=8f9c334a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9c334a",
  null
  
)

export default component.exports